export default __webpack_public_path__ + "static/media/bbq-ribs.53d564bd.jpg";